import fr from '../../resources/locales/fr-FR.json';
export default {
  ...fr,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['fr-FR'],
};
